exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-analytic-detail[data-v-8141b4f0] {\n  margin-bottom: 10px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/analytics-detail/PageAnalyticsDetail.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB","file":"PageAnalyticsDetail.vue","sourcesContent":["\n.page-analytic-detail[data-v-8141b4f0] {\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8141b4f0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/analytics-detail/PageAnalyticsDetail.vue
// module id = dJOp
// module chunks = 72